import { render, staticRenderFns } from "./devis.vue?vue&type=template&id=1bcdf5a0&scoped=true"
import script from "./devis.vue?vue&type=script&lang=js"
export * from "./devis.vue?vue&type=script&lang=js"
import style0 from "./devis.vue?vue&type=style&index=0&id=1bcdf5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcdf5a0",
  null
  
)

export default component.exports